import { emptyFragment } from '@execonline-inc/execonline-ui';
import { just } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { findLink } from '../../../../../../../LinkyLinky';
import { SchoolPartnerResource } from '../../../../../../../SegmentStore/Types';
import * as style from '../../../style.module.css';
import HeroSchoolPartnerLogoImage from './HeroSchoolPartnerLogoImage';

interface Props {
  schoolPartnerResource: SchoolPartnerResource;
}

const HeroSchoolPartnerLogo: React.FC<Props> = ({ schoolPartnerResource }) =>
  just(schoolPartnerResource.links)
    .andThen(findLink('logo-on-dark'))
    .map(({ href }) => {
      return (
        <div className={style.imageContainer}>
          <HeroSchoolPartnerLogoImage alt={schoolPartnerResource.payload.name.text} href={href} />
        </div>
      );
    })
    .getOrElse(emptyFragment);

export default observer(HeroSchoolPartnerLogo);
